<style>

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

</style>

<template lang="html">

<el-form ref="form" :model="form1" :rules="rules" v-form addAction="question/officialPost.action" label-width="80px">

    <el-form-item label="帖子摘要" prop="title">
        <el-input type="textarea" :maxlength="60" v-model="form1.title"></el-input>
    </el-form-item>
    <el-form-item label="封页图片">

        <el-upload class="avatar-uploader" accept="image/*" v-model="form1.imgs" :action="baseUrl+'upload/uploadPic'" :data="{floder:'question'}" :show-file-list="false">
            <img v-if="form1.imgs" :src="form1.imgs.url" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>

    </el-form-item>

    <el-form-item label="帖子类别" prop="categoryId">
        <el-select v-model="form1.categoryId">
            <el-option label="社区规范" value="9"></el-option>
            <el-option label="热门活动" value="10"></el-option>
            <el-option label="其他" value="8"></el-option>
        </el-select>
    </el-form-item>
    <el-form-item label="展示渠道" prop="channelId">
      <el-select v-model="form1.channelId" multiple placeholder="请选择渠道" :change="channelChange()">
        <el-option
          v-for="item in channelOptions"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="正文编辑" prop="activityInfo">
        <quill-editor v-model="form1.activityInfo" ref="myQuillEditor" :options="editorOption" style="width:100%;height: 267pt;">
        </quill-editor>
    </el-form-item>

    <el-form-item style="margin-top:100px;">
        <el-button type="primary">立即保存</el-button>
    </el-form-item>
</el-form>

</template>

<script>

import { quillEditor } from 'vue-quill-editor'
import { quillRedefine } from 'vue-quill-editor-upload'
import ChannelModel from '@/framework/models/channelModel'
import Config from '@/framework/configs/Config'
export default {
  data () {
    return {
      channelOptions: [],
      editorOption: {},
      baseUrl: Config.baseUrl,
      imageUrl: Config.imageUrl,
      form1: {
        activityInfo: null,
        channelId: [],
        title: '',
        categoryId: '',
        imgs: '',
        sourceType: 2,
        userId: -110
      },
      rules: {
        title: [{
          required: true,
          message: '请输入帖子内容',
          trigger: 'blur'
        } ],
        categoryId: [{
          required: true,
          message: '请输入帖子类别',
          trigger: 'change'
        } ],
        'form1.channelId': [{
          required: true,
          message: '请选择渠道',
          trigger: 'change'
        } ]
      }
    }
  },
  components: {
    quillEditor,
    quillRedefine

  },
  created: function () {
    let _this = this
    this.loadChannelList()

    this.editorOption = quillRedefine({
      toolOptions: [],
      // 以下所有设置都和vue-quill-editor本身所对应
      placeholder: '请输入内容1', // 可选参数 富文本框内的提示语
      theme: '', // 可选参数 富文本编辑器的风格
      handlers: {} // 可选参数 重定义的事件，比如link等事件
    }
    )
  },
  methods: {
    channelChange: function () {
      let _this = this
      let temp = []
      let channelstr = _this.form1.channelId.toString()
      if (channelstr.indexOf(-1) > -1) {
        for (var item of _this.channelOptions) {
          if (item.value == -1) {
            continue
          }
          temp.unshift(item.value)
        }
        _this.form1.channelId = temp

        console.log(_this.form1.channelId)
      }
    },
    loadChannelList: function () {
      let _this = this
      let listener = {
        success: function (dataInfo) {
          _this.channelOptions = [{		'label': '全选',
            'value': '-1' }]
          _this.channelOptions = _this.channelOptions.concat(dataInfo.datas)
        }
      }
      ChannelModel.findChannelSelectOption(this, listener)
    }
  }

}

</script>
